/* Max The Husky: Max habla en los momentos que importan (añadir al carrito, envio gratis) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PAW = '<svg viewBox="0 0 32 32" aria-hidden="true"><g fill="currentColor"><ellipse cx="16" cy="21.5" rx="7.2" ry="6.2"/><ellipse cx="6.6" cy="13.6" rx="3" ry="3.8" transform="rotate(-18 6.6 13.6)"/><ellipse cx="12.4" cy="7.6" rx="3" ry="4" transform="rotate(-6 12.4 7.6)"/><ellipse cx="19.6" cy="7.6" rx="3" ry="4" transform="rotate(6 19.6 7.6)"/><ellipse cx="25.4" cy="13.6" rx="3" ry="3.8" transform="rotate(18 25.4 13.6)"/></g></svg>';
  var COLORS = ['#0A4FD6', '#FFC93C', '#FF6FA8', '#16181D'];

  function burst(el, n) {
    if (reduce || !el) return;
    var r = el.getBoundingClientRect(), x = r.left + r.width / 2, y = r.top + r.height / 2;
    n = n || 8;
    for (var i = 0; i < n; i++) {
      var p = document.createElement('span');
      p.className = 'max-fx-paw';
      p.innerHTML = PAW;
      var a = (Math.PI * 2 * i) / n + Math.random() * 0.6, d = 60 + Math.random() * 60;
      p.style.cssText = 'left:' + x + 'px;top:' + y + 'px;color:' + COLORS[i % 4] +
        ';--dx:' + Math.cos(a) * d + 'px;--dy:' + (Math.sin(a) * d - 30) + 'px;--r:' + (Math.random() * 90 - 45) + 'deg';
      document.body.appendChild(p);
      setTimeout(p.remove.bind(p), 1000);
    }
  }

  var toastTimer;
  function say(text) {
    var t = document.getElementById('MaxSays');
    if (!t) {
      t = document.createElement('div');
      t.id = 'MaxSays'; t.className = 'max-says'; t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = '<span class="max-says__paw">' + PAW + '</span><span></span>';
    t.lastChild.textContent = text;
    t.classList.remove('is-on'); void t.offsetWidth; t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  function bumpCart() {
    var icon = document.querySelector('#cart-icon-bubble');
    if (!icon || reduce) return;
    icon.classList.remove('max-bump'); void icon.offsetWidth; icon.classList.add('max-bump');
  }

  function confetti() {
    if (reduce) return;
    for (var i = 0; i < 46; i++) {
      var c = document.createElement('span');
      c.className = 'max-fx-confetti';
      c.style.cssText = 'left:' + Math.random() * 100 + 'vw;background:' + COLORS[i % 4] +
        ';animation-delay:' + Math.random() * 0.35 + 's;--r:' + Math.random() * 720 + 'deg;--x:' + (Math.random() * 80 - 40) + 'px';
      document.body.appendChild(c);
      setTimeout(c.remove.bind(c), 2400);
    }
  }

  window.MaxFun = { burst: burst, say: say, confetti: confetti };

  /* Añadir al carrito: huellas al pulsar, Max celebra cuando el producto entra de verdad */
  var lastBtn = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.product-form__submit, [data-max-sticky-btn], .quick-add__submit');
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
    lastBtn = b;
    burst(b, 8);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!ev || ev.source !== 'product-form') return;
      bumpCart();
      say('I love youuu! Ya está en tu carrito');
    });
  }

  /* Envio gratis: confeti + Max lo anuncia, una vez por sesion */
  var done = false;
  try { done = sessionStorage.getItem('maxFree') === '1'; } catch (err) {}
  function checkFree() {
    if (done) return;
    var s = document.querySelector('cart-drawer.active .max-ship.is-free, .template-cart .max-ship.is-free, main .max-ship.is-free');
    if (s) {
      done = true;
      try { sessionStorage.setItem('maxFree', '1'); } catch (err) {}
      confetti();
      say('¡Jamooon! Envío gratis desbloqueado');
    }
  }
  new MutationObserver(checkFree).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();
